/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%}.main[_ngcontent-%COMP%]{display:flex;height:100%;overflow:auto}.content[_ngcontent-%COMP%]{flex:1;overflow:auto}"];
export { styles as styles };
